import ApplicationController from "./application_controller";
import Cleave from "cleave.js";

export default class extends ApplicationController {
  static targets = [ "input", "percentageInput"]

  initialize() {
    new Cleave("#agreement_percentage", {
      numeral: true,
      prefix: ' %',
      tailPrefix: true,
      numeralIntegerScale: 2
  });
  }

  toggleAgreement(e) {
    this.inputTargets.forEach( (target) => {
      if (e.currentTarget == target) return;
      target.checked = false;
      const disabledInput = this.element.querySelector(`#${target.dataset.inputId}`)
      disabledInput.setAttribute('disabled', true);
      disabledInput.value = '';
    })
    const selectedInput = this.element.querySelector(`#${e.currentTarget.dataset.inputId}`);
    selectedInput.removeAttribute('disabled');
    selectedInput.focus();
  }
}